const COMMUNITY_GOVERNED_DESCRIPTION =
  "Formfunction is community governed, and our artists and collectors " +
  "collectively vote to decide who to onboard next. If you're " +
  " interested in joining Formfunction as an artist, fill out the form " +
  "below to submit your application!";

export default COMMUNITY_GOVERNED_DESCRIPTION;
